import { render, staticRenderFns } from "./BankAccountTableList.vue?vue&type=template&id=27f4b08a"
import script from "./BankAccountTableList.vue?vue&type=script&lang=js"
export * from "./BankAccountTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports